import type {View} from "../../../data/models/View";
import type {Report} from "../../../data/models/Report";
import type {IViewFolder} from "../../../data/models/ViewUtils";
import {ViewPreferenceCategory} from "../../../generated/api/base";
import {XyiconFeature} from "../../../generated/api/reports";
import {ViewFolderSharingPopup} from "./ViewFolderSharingPopup";
import {ViewSharingPopup} from "./ViewSharingPopup";
import ReportSharingContainer from "./ReportSharingContainer";

interface IViewItemSharingPopupProps {
	readonly viewItem: View | IViewFolder | Report;
	readonly onClose: () => void;
}

export const ViewItemSharingPopup = (props: IViewItemSharingPopupProps) => {
	const {viewItem, onClose} = props;

	if ((viewItem as IViewFolder).category === ViewPreferenceCategory.Folder) {
		return (
			<ViewFolderSharingPopup
				viewFolder={viewItem as IViewFolder}
				onClose={onClose}
			/>
		);
	} else if ((viewItem as Report).ownFeature === XyiconFeature.Report) {
		return (
			<ReportSharingContainer
				report={viewItem as Report}
				onClose={onClose}
			/>
		);
	}

	return (
		<ViewSharingPopup
			view={viewItem as View}
			onClose={onClose}
		/>
	);
};
